export default __webpack_public_path__ + "static/protocol-desktop-a53ff6adb262deb6c1a5823737c69500.png";